export default "__VITE_ASSET__CEOoBPAA__"